import ErrorHandler from '@/components/Error/ErrorHandler'
import SaldoAntecipadoItem from '@/components/Fatura/SaldoAntecipadoItem'
import '@/components/Fatura/SaldoAntecipado.scss'
import Footer from '@/components/Footer'
import Loading from '@/components/Loading'
import Logo from '@/components/Logo'
import useAuth from '@/contexts/useAuth'
import useEmpresa from '@/contexts/useEmpresa'
import { getSaldoAntecipado } from '@/services/saldo-antecipado'
import { formatMoney } from '@/utils'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

export default function GuestSaldoAntecipado() {
    const { t } = useTranslation()
    const { clienteHash } = useParams<{ clienteHash: string }>()
    const { user } = useAuth()
    const { empresa } = useEmpresa()
    const [disponivel, setDisponivel] = useState(0)
    const [extrato, setExtrato] = useState<Awaited<ReturnType<typeof getSaldoAntecipado>>['extrato']>([])
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<Error | null>(null)

    useEffect(() => {
        if (!user?.CdCliente || !clienteHash) return

        let cancelled = false
        ;(async () => {
            setIsLoading(true)
            try {
                const data = await getSaldoAntecipado(clienteHash)
                if (cancelled) return
                setDisponivel(data.disponivel)
                setExtrato(data.extrato)
            } catch (err) {
                if (!cancelled) setError(err as Error)
            } finally {
                if (!cancelled) setIsLoading(false)
            }
        })()

        return () => {
            cancelled = true
        }
    }, [user?.CdCliente, clienteHash])

    if (error) return <ErrorHandler error={error} />
    if (!user || !empresa || isLoading) return <Loading type="primary" />

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <header>
                <div className="nav-container">
                    <Logo className="logo" />
                </div>
                <div className="right">
                    <div className="hello">
                        <span>{t('Olá')}, </span>
                        <strong>{user.Nome?.split(' ')[0]}</strong>
                    </div>
                </div>
            </header>

            <main style={{ padding: 12, flex: 1 }}>
                <div className="flex flex-col gap-4">
                    <div className="flex flex-wrap items-center justify-between gap-3">
                        <Link className="btn btn-outline-primary btn-sm" to={`/c/${clienteHash}/faturas`}>
                            {t('Voltar')}
                        </Link>
                        <h1 className="m-0 text-lg font-bold text-slate-900">{t('Saldo Antecipado')}</h1>
                    </div>

                    <div className="saldo-antecipado-summary">
                        <span className="saldo-antecipado-summary-label">{t('Saldo Disponível')}</span>
                        <strong className="saldo-antecipado-summary-valor">{formatMoney(disponivel)}</strong>
                    </div>

                    {extrato.length === 0 ? (
                        <p className="saldo-antecipado-empty">{t('Nenhum movimento de saldo')}</p>
                    ) : (
                        <div className="saldo-antecipado-list">
                            {extrato.map((item, index) => (
                                <SaldoAntecipadoItem
                                    key={`${item.Operacao}-${item.CdSaldo}-${item.Data ?? ''}-${index}`}
                                    item={item}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </main>

            <Footer />
        </div>
    )
}
